import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataProperties } from 'src/app/core/models/data-properties.model';
import { Subject } from 'rxjs';
import { LoaderMessagingService } from 'src/app/core/services/messaging/loader-messaging.service';
import { studentDataProperties } from 'src/app/core/constants/configuration/order-constants.config';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'student-details-list',
  templateUrl: './student-details-list.component.html',
  styleUrls: ['./student-details-list.component.scss']
})
export class StudentDetailsListComponent implements OnInit {

  @Input() items: any[] = [];
  @Output() getSelectedStudent = new EventEmitter<any>();

  dataProperties: DataProperties[];
  headersLength: number;
  isLoading: boolean = false;
  unsubscribe: Subject<any> = new Subject();

  constructor(
    private loaderMessagingService: LoaderMessagingService,
  ) {
    this.subscribeToLoaderMessagingService();
  }

  ngOnInit() {
    this.dataProperties = studentDataProperties;
    this.headersLength = this.dataProperties.length;
  }

  formatAmount(value: number): string {
    return value < 0 ? `$ (${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')})`
      : `$ ${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
  }

  private subscribeToLoaderMessagingService(): void {
    this.loaderMessagingService.listLoader$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(show => setTimeout(() => (this.isLoading = show)));
  }

  onCheckboxCheck($event: any, selected: any) {
    if ($event.checked) {
      this.items.forEach(item => {
        if(item.id !== selected.id) {
          item.check = false;
        }
      });
      this.getSelectedStudent.emit(selected);
    } else {
      this.getSelectedStudent.emit(null);
    }
  }


}
